import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/ChartDataQuery'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class ChartDataQueryStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "ChartDataQueryStore",
			variables: true,
		})
	}
}

export async function load_ChartDataQuery(params) {
  await initClient()

	const store = new ChartDataQueryStore()

	await store.fetch(params)

	return {
		ChartDataQuery: store,
	}
}
